import { render } from "./WidgetCard.vue?vue&type=template&id=73e0754f&scoped=true"
import script from "./WidgetCard.vue?vue&type=script&lang=js"
export * from "./WidgetCard.vue?vue&type=script&lang=js"

import "./WidgetCard.vue?vue&type=style&index=0&id=73e0754f&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e0754f"]])

export default __exports__